import { render, staticRenderFns } from "./BuildIndividualAccounts.vue?vue&type=template&id=749f318d&scoped=true"
import script from "./BuildIndividualAccounts.vue?vue&type=script&lang=js"
export * from "./BuildIndividualAccounts.vue?vue&type=script&lang=js"
import style0 from "./BuildIndividualAccounts.vue?vue&type=style&index=0&id=749f318d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "749f318d",
  null
  
)

export default component.exports